import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { AppUtils } from 'src/app/helpers';
import { RolesFilterOptionsDetail } from 'src/app/helpers/constants/filter-and-search/user.roles.and.access-groups.options';
import { clientListColumnDetails } from 'src/app/helpers/constants/staff/grid.column.detail';
import { FilterBy, FilterInputModel, FilterModel, SearchByModel } from 'src/app/models/shared/filters.model';
import { SearchModel } from 'src/app/models/shared/search.model';
import { StaffService } from 'src/app/services/staff.serrvice';

@Component({
  selector: 'app-users-role-search-and-filter',
  templateUrl: './users-role-search-and-filter.component.html',
  styleUrls: ['./users-role-search-and-filter.component.css']
})
export class UsersRoleSearchAndFilterComponent implements OnInit {

  filterBy: FilterInputModel[] = [];

  @Output()
  onApplyFilter = new EventEmitter();

  @Output()
  resetFilters = new EventEmitter();

  // capture filter open and close events
  @Input() filterStatusParent: boolean;
  @Output() closeBtnFilterStatus = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
    RolesFilterOptionsDetail.forEach((x, y) => {
      this.filterBy.push({ name: x, id: y });
    });
  }

  applyFilter(filterData: any): void {
    this.onApplyFilter.emit(filterData);
  }

  onResetFilters(): void {
    this.resetFilters.emit();
  }

  // capture filter open and close events
  closeEvent(somedata: boolean): void {
    this.filterStatusParent = somedata;
    this.closeBtnFilterStatus.emit(somedata);
  }

}
